import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Testimonial } from '../models/testimonial.model';
import { AngularFirestore, QueryDocumentSnapshot, DocumentData, DocumentReference } from '@angular/fire/firestore';
import { map } from 'rxjs/operators';
import { MailService } from './mail.service';
import { Practitioner } from '../models/practitioner.model';
import { Rating } from '../models/rating.model';

@Injectable()
export class TestimonialService {

  constructor(private firestore: AngularFirestore, private mailService: MailService){}

  getTestimonials(practitionerId: string): Observable<Testimonial[]> {
    return this.firestore.collection('practitioners').doc(practitionerId).collection('testimonials').get()
      .pipe(map(query => {
        var testimonials: Testimonial[] = [];
        query.forEach((document: QueryDocumentSnapshot<DocumentData>) => {
          testimonials.push(Testimonial.mapFromFirestore(document.data(), document.id));
        });
        return testimonials;
      }));
  }

  createTestimonial(practitionerId: string, testimonial: Testimonial, rating?: Rating): Promise<Testimonial> {
    return new Promise<Testimonial>((resolve, reject) => {
      this.firestore.collection('practitioners').doc(practitionerId).collection('testimonials').add(testimonial.mapToFirestore()).then((docRef: DocumentReference) => {
        testimonial.id = docRef.id;
        this.updatePractitionerRating(practitionerId, testimonial, rating);
        resolve(testimonial);
      }, _  => {
        reject('There was an error submitting your testimonial.');
      });
    });
  }

  createTestimonials(practitionerId: string, testimonials: Testimonial[]) {

  }

  updateTestimonial(practitionerId: string, testimonial: Testimonial) {

  }

  deleteTestimonial(practitionerId: string, testimonial: Testimonial) {

  }

  sendTestimonialEmail(practitioner: Practitioner, testimonials: Testimonial[]) {
    this.mailService.sendTestimonialEmail(practitioner, testimonials);
  }

  updatePractitionerRating(practitionerId: string, testimonial: Testimonial, rating?: Rating) {
      if (rating) {
        rating.rating = ((rating.rating * rating.total) + testimonial.rating) / (rating.total + 1);
        rating.total = rating.total + 1;
        rating.updatedAt = new Date().getTime();
      } else {
        rating = new Rating(testimonial.rating, 1, new Date().getTime(), {});
      }

      testimonial.values.forEach((value: string) => {
        rating.values[value] = rating.values[value] ? rating.values[value] + 1 : 1;
      });

      this.firestore.collection('practitioners').doc(practitionerId).update({ 'rating': rating.mapToFirestore() });
  }
}
